/* eslint-disable react-hooks/exhaustive-deps */
import { StackedBarChart } from 'components/Charts/StackedBarChart'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
// import { all as allDrawer } from 'store/Sidebar/Sidebar.selector'
import { traceabilityTablesActions } from 'store/TraceabilityTables'
import { all } from 'store/TraceabilityTables/TraceabilityTables.selector'

import * as S from './styled'
import { Accordion } from 'components/Accordion'

export function InvoicesChart() {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const monthsTranslation = t('common:months')
  const amountTranslation = t('common:amount')
  const invoicesTranslation = t('common:invoices')

  const { invoicesByMonth, chartsLoading, filters } = useSelector(all)
  // const { persistent } = useSelector(allDrawer)

  useEffect(() => {
    if (filters.begin && filters.end && !chartsLoading) {
      dispatch(
        traceabilityTablesActions.getKpisCharts({
          ...filters,
          charts: ['invoicesByMonth'],
          years: filters.years.length
            ? filters.years
            : [new Date().getFullYear()]
        })
      )
    }
  }, [dispatch, filters])

  return (
    <S.Wrapper>
      <Accordion title={invoicesTranslation}>
        <StackedBarChart
          data={invoicesByMonth}
          xAxisTitle={monthsTranslation}
          yAxisTitle={amountTranslation}
          height={380}
          isLoading={chartsLoading}
          labels={{
            inNatura: t('common:inNature'),
            inNaturaRastreada: t('common:tracked_chart'),
            inNaturaParcial: t('common:partially'),
            inNaturaNaoRastreada: t('common:notTracked'),
            inNaturaPendente: t('common:pending'),
            industrializados: t('common:industrialized'),
            industrializadosRastreada: t('common:tracked_chart'),
            industrializadosParcial: t('common:partially'),
            industrializadosNaoRastreada: t('common:notTracked'),
            industrializadosPendente: t('common:pending')
          }}
        />
      </Accordion>
    </S.Wrapper>
  )
}
